/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/indent */
import React, { useEffect, useState } from 'react';
import { Card, Typography } from '@pwskills/rachnaui';
import { getRandomId } from '@/components/common/video/utils';
import { s3Url } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';
import { COURSE_PURCHASE_TYPE, CourseTypes } from '@/utils/common/common.constants';
import useIsCourseBought from '@/hooks/useIsCourseBought';
import useUserDetails from '@/store/userDetails';
import { IMappedCourseDetails } from '@/interfaces/courseDescription';
import useUserCourseDetails from '@/store/userCoursesDetails';
import { encodeSlugUrl, createImageUrl } from '@/utils/helper/helperFunction';
import { AuthEnums, RESPONSE_STATUS } from '@/GlobalEnums/enums';
import { CoursesType } from '@/interfaces/courseListing.enum';
import { GAevent } from '@/utils/firebase.utils';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import ArrowRight from '@/assets/icons/ArrowRight';
import { usePWAuthWebSDK } from '@/hooks/usePWAuthWebSDK';
import { sendSkCourseCardClickEvent, sendSkCtaClickedEvent } from '@/utils/GAEventFunction';
import { setNavigationContext } from '@/utils/navigationContext';
import { ICourses } from '../../../interfaces/homePage';
import { DOMAIN } from '../../../utils/homePage/env.constants.utils';
import { dataLayer } from '../../../utils/common/dataLayer.utils';
import Toaster from '../Toaster';

type Props = {
  // smallerCards: boolean;
  // learnPage: boolean;
  course: ICourses;
  pageFrom?: string;
  categorySlug?: string;
  categoryName?: string;
  categoryId?: string;
  section?: string;
  position?: string;
  cardPosition?: number;
  courseType: string;
  planCourses?: string;
  sectionFrom?: string;
  isStickyNavBar?: boolean;
  isDescriptionPage?: boolean;
};

const CourseCardRevamp = ({
  course,
  pageFrom,
  categorySlug,
  categoryName,
  categoryId,
  section,
  position,
  cardPosition,
  courseType,
  planCourses,
  sectionFrom,
  isStickyNavBar,
  isDescriptionPage,
}: Props) => {
  const {
    img,
    name,
    title,
    slug,
    _id,
    hashTag,
    coursePurchaseType,
    thumbnailImgAltText,
    parentCategoryDetails,
    categoryDetails,
    // duration,
    userCount,
  } = course || {};
  const resolvedPricing = course?.courseMetaDetails?.pricing || course?.pricing;

  const router = useRouter();
  const utmQuery = useUTMParameters();

  const sendDataLayerEvent = (type: string) => {
    const dataLayerObj = {
      event: 'course_card_click',
      category_id: categoryId || parentCategoryDetails?._id || categoryDetails?._id,
      click_text: type,
      section: section || '',
      course_name: name || title,
      course_id: _id,
      course_type: coursePurchaseType,
      source_page: pageFrom,
    };
    dataLayer(dataLayerObj);
  };

  const goToPlanSection = () => {
    const sections = document.getElementById('plans');
    const sectionTop = Number(sections?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  const [mappedCourseDetails, setMappedCourseDetails] = useState<IMappedCourseDetails>({
    courseId: '',
    courseSlug: '',
    purchasedCourseSlug: '',
    purchasedCourseType: '',
  });
  const {
    checkIsCourseBought,
    returnLessonId,
    handleMappedCourses,
    isCourseBoughtForPlan,
    planCourseMappedDetails,
    planTypeCourseBought,
  } = useIsCourseBought();
  const { userDetails: user, userIsLoggedIn: isLoggedIn, isUserPaid } = useUserDetails();
  const cName = router.query.courseSlug;
  const { userCoursesMap } = useUserCourseDetails();
  const [lessonId, setLessonId] = useState('');
  const [isCourseBought, setIsCourseBought] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState({ isError: false, message: '' });
  const [openToaster, setOpenToaster] = useState(false);

  const { initApp } = usePWAuthWebSDK({
    sdkProps: {
      themeFor: 'skills',
      onGoogleSignIn: () => {
        // your logic
      },
      googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      cameFrom: AuthEnums.BLOG,
      ctaName: AuthEnums.LOGIN,
      formLocation: pageFrom || 'course_card',
    },
    onAuthSuccessCallBack: () => {
      router.push(`/checkout?course_id=${course?._id}`);
    },
  });

  const handleClickWithRedirect = (redirectUrl: string) => {
    if (isLoggedIn) {
      router.push(redirectUrl);
      return;
    }
    initApp();
  };

  const sendGAEvent = (courseName: string, courseID: string, sectionName: string) => {
    GAevent('sk_course_watch', {
      user_id: user.id,
      user_name: `${user.firstName} ${user.lastName}`,
      user_email: user.email,
      user_phonenumber: `${user.isdCode} ${user.phoneNumber}`,
      course_name: courseName,
      course_id: courseID,
      section_name: sectionName,
    });
  };

  const sendGAevent = (source: string) => {
    const GAEventData = {
      source,
      ...utmQuery,
    };
    GAevent('sk_login_page_visit', GAEventData);
  };

  const handleGAEvent = (action: string) => {
    const rawPosition = position ?? (router?.query?.position as string | undefined);
    const parsedPosition = rawPosition !== undefined ? Number(rawPosition) : undefined;
    const resolvedCardPosition =
      typeof cardPosition === 'number'
        ? cardPosition
        : Number.isNaN(parsedPosition as number)
        ? undefined
        : parsedPosition;
    const rawResolvedPrice = resolvedPricing?.IN ?? resolvedPricing?.US;
    const rawResolvedDiscount = resolvedPricing?.discount;
    const eventPrice =
      typeof rawResolvedPrice === 'number' && rawResolvedPrice > 0 ? rawResolvedPrice : undefined;
    const eventDiscount =
      typeof rawResolvedDiscount === 'number' && rawResolvedDiscount > 0
        ? rawResolvedDiscount
        : undefined;

    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      user_category: user?.userType || '',
      action,
      page_name: pageFrom,
      page_ref: router.query.page_ref || '',
      category_id: categoryId || categoryDetails?._id || parentCategoryDetails?._id,
      categoryName:
        categoryName ||
        categoryDetails?.name ||
        categoryDetails?.title ||
        parentCategoryDetails?.title,
      course_name: name || title,
      course_id: _id,
      course_type: courseType,
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
      click_text: 'card',
    };
    sendSkCourseCardClickEvent({
      userData: user,
      isLoggedIn,
      isUserPaid,
      page_path: router?.pathname,
      page_referrer_cta: (router?.query?.clickText as string) || 'course card',
      page_referrer_widget_name: (router?.query?.section as string) || section || '',
      card_id: _id,
      card_title: name || title,
      card_category:
        categoryName ||
        categoryDetails?.name ||
        categoryDetails?.title ||
        parentCategoryDetails?.title,
      card_position: resolvedCardPosition,
      card_section: section || sectionFrom || pageFrom || '',
      course_batch_name: name || title,
      course_batch_slug: slug || '',
      course_batch_category:
        categoryName ||
        categoryDetails?.name ||
        categoryDetails?.title ||
        parentCategoryDetails?.title,
      course_batch_id: _id,
      course_batch_cohort_id: categoryId || categoryDetails?._id || parentCategoryDetails?._id,
      price: eventPrice,
      discount_percentage: eventDiscount,
      is_free: resolvedPricing?.isFree ?? courseType === CoursesType.FREE,
    });

    GAevent('sk_course_card_click', GAEventData);
  };

  useEffect(() => {
    if (isLoggedIn) {
      // getIsCourseBought();

      if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN && planCourses) {
        setIsCourseBought(isCourseBoughtForPlan(planCourses));
        setMappedCourseDetails(planCourseMappedDetails(planCourses));
      } else {
        setIsCourseBought(checkIsCourseBought(course._id as string));
        setMappedCourseDetails(handleMappedCourses(course._id as string));
      }
      setLessonId(returnLessonId(course._id as string));
    }
  }, [course._id, isLoggedIn, userCoursesMap]);

  const goToMyCourseFunction = () => {
    const sectionParam = sectionFrom ? `&section=${sectionFrom}` : '';

    if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN) {
      // coming from description page
      if (planCourses) {
        if (planTypeCourseBought?.purchasedCourseType === CourseTypes.PLACEMENT)
          router.push(
            `${DOMAIN}/learn/career-path/${encodeSlugUrl(
              planTypeCourseBought?.slug || (slug as string)
            )}/${planTypeCourseBought?.courseId}/dashboard?from=${router.asPath}`
          );
        else if (mappedCourseDetails?.lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${encodeSlugUrl(
              planTypeCourseBought?.slug || (slug as string)
            )}/${planTypeCourseBought?.courseId}/lesson/${mappedCourseDetails?.lessonId}?from=${
              router.asPath
            }&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else if (lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slug || ''}/${course._id}/lesson/${lessonId}?from=${
              router.asPath
            }&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else {
          setToastMessage({ isError: true, message: 'Course has not started yet' });
          setOpenToaster(true);
        }
      } else {
        // coming from description page
        const slugUrl = encodeSlugUrl(
          (mappedCourseDetails?.purchasedCourseSlug as string) || title || (slug as string)
        );
        if (mappedCourseDetails?.purchasedCourseType === CourseTypes.PLACEMENT)
          router.push(
            `${DOMAIN}/learn/career-path/${slugUrl}/${course?._id}/dashboard?from=${router.asPath}`
          );
        else if (mappedCourseDetails?.lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slugUrl}/${course?._id}/lesson/${mappedCourseDetails?.lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else if (lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slugUrl}/${course?._id}/lesson/${lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else {
          setToastMessage({ isError: true, message: 'Course has not started yet' });
          setOpenToaster(true);
        }
      }
    } else if (courseType && courseType === CourseTypes.PLACEMENT)
      router.push(
        `${DOMAIN}/learn/career-path/${slug}/${course?._id}/dashboard?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
      );
    else if (lessonId)
      router.push(
        `${DOMAIN}/learn/course/${slug}/${course?._id}/lesson/${lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
      );
    else {
      setToastMessage({ isError: true, message: 'Course has not started yet' });
      setOpenToaster(true);
    }
  };

  const handleCourseBtnGAEvent = () => {
    sendGAEvent(cName as string, course?._id as string, 'Go to Course Button');
  };

  // Function to get the appropriate image URL
  const getImageUrl = () => {
    if (course?.previewImageUrl) {
      return course.previewImageUrl.startsWith('https')
        ? course.previewImageUrl
        : createImageUrl(course.previewImageUrl);
    }
    if (img) {
      return img.startsWith('https') ? img : `${s3Url}/assets/uploads/thumbnails/${img}`;
    }

    return '';
  };

  return (
    <Card
      key={getRandomId()}
      className="flex mt-5 relative min-h-[280px] !mx-3 large:!mx-6 rounded-b-[20px] rounded-t-[20px] shadow-light shrink-0 flex-col  hover:shadow-[0px_4px_25px_rgba(0,0,0,0.10)] bg-white !p-0 !m-0 !w-[302px] cursor-pointer transition-all duration-500"
      onClick={() => handleGAEvent('card_click')}
    >
      <div
        className="flex flex-col flex-grow"
        onClick={() => {
          sendDataLayerEvent('card');
          const targetPath = `/${categorySlug || 'course'}/${slug}`;
          const navigationContext = {
            from: pageFrom,
            position,
            categoryName,
            categorySlug,
          };
          setNavigationContext(targetPath, navigationContext);
          router.push(`${DOMAIN}${targetPath}`);
        }}
      >
        <div className="mx-auto w-full col-span-2 pt-4 px-4">
          <div className="relative">
            {courseType === CoursesType.FREE && (
              <div className="absolute top-0 left-0 !z-[9999] ml-2 mt-2">
                <Typography
                  component="body-small"
                  variant="bold"
                  className="bg-[#E97862] text-[#FFF] !text-[10px] rounded-[56px] px-2 py-[2px] !leading-4"
                >
                  Free
                </Typography>
              </div>
            )}
            {hashTag && hashTag?.value && courseType !== CoursesType.FREE && (
              <div className="absolute top-0 left-0 !z-[999] ml-2 mt-2">
                <Typography
                  component="body-small"
                  variant="bold"
                  className="bg-[#F7E0B4] text-[#543D11] !text-[10px] rounded-[56px] px-2 py-1 !leading-4"
                >
                  {hashTag?.value}
                </Typography>
              </div>
            )}
            <img
              src={getImageUrl()}
              alt={thumbnailImgAltText}
              className="!w-full rounded-[6px] h-[154px] medium:!w-[270px] object-cover"
              loading="eager"
            />
          </div>
        </div>
        <div className="flex flex-col justify-between gap-4 medium:gap-2 large:gap-3 flex-grow px-4 pb-4 pt-2">
          <div className="flex flex-col justify-between gap-2 medium:gap-2 h-full">
            <div className="flex flex-row !justify-between min-h-12 ">
              <Typography
                component="body-regular"
                variant="bold"
                className="text-gray-900 line-clamp-2 !leading-6 !text-[16px] break-words"
              >
                {name || title}
              </Typography>
            </div>
            <div className="flex flex-col gap-2">
              <div className="w-[270px] bg-[#EFEFEF] h-[1px]" />

              <div className="flex gap-2">
                {course?.config?.duration && (
                  <div className="flex gap-1 items-center">
                    <img
                      src="/images/homePageRevamp/time.svg"
                      alt="clock-img"
                      className="w-4 h-4"
                    />
                    <Typography
                      component="body-small"
                      variant="semi-bold"
                      className="text-gray-650 !text-sm"
                    >
                      {course?.config?.duration ? course?.config?.duration?.slice(0, 16) : ''}
                    </Typography>
                  </div>
                )}
                {userCount &&
                new Date() >
                  new Date(course?.registrationStartDate || course?.registration?.startDate) ? (
                  <div className="flex items-center gap-1">
                    <img
                      src="/images/homePageRevamp/users.svg"
                      alt="random-ndnd"
                      className="w-4 h-4"
                    />
                    <Typography
                      component="body-small"
                      variant="semi-bold"
                      className="text-gray-650 !text-sm"
                    >
                      {userCount && userCount > 500
                        ? '1000+'
                        : userCount && userCount > 100
                        ? '500+'
                        : userCount || 0}{' '}
                      Enrolled
                    </Typography>
                  </div>
                ) : (
                  <div />
                )}
              </div>

              {courseType === 'free' && (
                <button
                  // variant="secondary"
                  type="button"
                  className="relative w-full bg-white font-extrabold large:!font-bold text-[#E58471] mt-2 py-2 pl-[18px] pr-2 gap-0 z-10 hover:bg-[#E97862] hover:text-white border border-[#E97862] rounded-[4px] flex justify-center items-center transition-all duration-500 text-sm max-h-10"
                  onClick={(e) => {
                    e.stopPropagation();
                    sendSkCtaClickedEvent({
                      userData: user,
                      isLoggedIn,
                      isUserPaid,
                      page_path: router?.pathname,
                      click_type: 'route',
                      click_text: 'Enroll for Free',
                      click_id: 'enroll_for_free',
                      click_position: section || 'course_card',
                      widget_name: section || 'course_card',
                      page_referrer_cta: (router?.query?.clickText as string) || '',
                      page_referrer_widget_name: (router?.query?.section as string) || '',
                      course_name: title || '',
                      course_slug: slug || '',
                      course_category: categoryName || parentCategoryDetails?.title || '',
                      course_id: _id || '',
                      price: resolvedPricing?.IN ?? resolvedPricing?.US,
                      discount_percentage: resolvedPricing?.discount,
                      is_free: true,
                    });

                    handleGAEvent('enroll for free');
                    if (!isLoggedIn) {
                      sendGAevent('Free Course');
                    }
                    if (isCourseBought && isLoggedIn) {
                      goToMyCourseFunction();
                    } else if (
                      (isDescriptionPage || isStickyNavBar) &&
                      coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN
                    ) {
                      goToPlanSection();
                    }
                    // if plan type course scroll to plan section
                    else if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN) {
                      router.push(
                        `/${
                          categorySlug || 'course'
                        }/${slug}/?goToPlanSection=true&source=${pageFrom}&source_position=course_buy_now`
                      );
                    } else if (isLoggedIn && !isCourseBought) {
                      if (pageFrom === 'course_listing') {
                        router.push(`/checkout?course_id=${course?._id}&source=listing_page`);
                      } else {
                        router.push(`/checkout?course_id=${course?._id}&source=home_page`);
                      }
                    } else {
                      handleClickWithRedirect(`/checkout?course_id=${course?._id}`);
                    }
                    if (isCourseBought) handleCourseBtnGAEvent();
                  }}
                >
                  <Typography
                    component="body-small"
                    variant="semi-bold"
                    className="text-inherit font-inter leading-[22px]"
                  >
                    Enroll for Free
                  </Typography>
                  <ArrowRight className="w-6 h-6 text-inherit" />
                  {/* <img
                    src="/images/homePageRevamp/ArrowRightOrange.svg"
                    alt="right-arrow-img"
                    className="w-6 h-6 text-inherit"
                  /> */}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {openToaster && (
        <Toaster
          open={openToaster}
          setOpen={setOpenToaster}
          text={toastMessage.message}
          variant={toastMessage?.isError ? RESPONSE_STATUS.ERROR : RESPONSE_STATUS.SUCCESS}
        />
      )}
    </Card>
  );
};

export default CourseCardRevamp;
